export default __webpack_public_path__ + "static/media/Pistol_5.c8607601.png";